import { UnknownTokenLogo } from "./Unknown";
import { Chain, TokenWithChain } from "@src/models";

type Props = {
  token?: TokenWithChain;
  tokenLogoClassName?: string;
  unknownTokenLogoClassName?: string;
  withChain?: boolean;
  chainLogoClassName?: string;
  chain?: Chain;
};
export const TokenLogo = ({
  token,
  tokenLogoClassName,
  unknownTokenLogoClassName,
  withChain = false,
  chainLogoClassName,
  chain,
}: Props) => {
  if (!token) {
    return (
      <UnknownTokenLogo tokenName={"?"} className={unknownTokenLogoClassName} />
    );
  }

  return token?.image ? (
    <div
      className={`relative flex items-end ${withChain && chain ? "pr-1" : ""}`}
    >
      <img
        src={token.image}
        alt={token.name}
        className={`rounded-2xl shadow ${tokenLogoClassName}`}
      />
      {withChain && chain && (
        <img
          src={chain.image}
          alt={chain.name}
          className={`absolute right-0 rounded-3xl w-4 h-4 ${chainLogoClassName}`}
        />
      )}
    </div>
  ) : token ? (
    <UnknownTokenLogo
      tokenName={token.name!}
      className={unknownTokenLogoClassName}
    />
  ) : null;
};
